import * as Errors_en from './Errors.en.js';
import * as Errors_es from './Errors.es.js';

const ErrorsTuple = [
  { type: 'Errors', language: 'en', object: Errors_en.default },
  { type: 'Errors', language: 'es', object: Errors_es.default },
];

export default ErrorsTuple;
